export const listLanguage = {
  defaultLang: "en",
  listLang: ["en", "ru"],
}